import { render } from "./ViewPayrollDeductions.vue?vue&type=template&id=57849200"
import script from "./ViewPayrollDeductions.vue?vue&type=script&lang=js"
export * from "./ViewPayrollDeductions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__